
/**
 * @description 外卖订单状态
 *  使用示例
 * console.log(TakeoutOrderStatus.PENDING_MEAL.description); // '待出餐'
 *console.log(TakeoutOrderStatus.getDescription('1')); // '已接单'
 *console.log(TakeoutOrderStatus.getColor('2')); // '#1890ff'
console.log(TakeoutOrderStatus.isValid('0')); // true
console.log(TakeoutOrderStatus.getNextStatus('1')); // '2'
 */
export const TakeoutOrderStatus = Object.freeze({
  PENDING_MEAL: {
    value: '0',
    description: '待出餐',
    color: '#ffa500'  // 橙色 - 待处理状态
  },
  ACCEPTED: {
    value: '1',
    description: '已接单', 
    color: '#1890ff'   // 蓝色 - 进行中状态
  },
  DELIVERING: {
    value: '2', 
    description: '配送中',
    color: '#1890ff'   // 蓝色 - 进行中状态
  },
  DELIVERED: {
    value: '3',
    description: '已送达',
    color: '#52c41a'   // 绿色 - 成功状态
  },
  COMPLETED: {
    value: '4',
    description: '已完成',
    color: '#52c41a'   // 绿色 - 成功状态
  },
  PAUSED: {
    value: '5',
    description: '已暂停',
    color: '#faad14'   // 黄色 - 警告/暂停状态
  },
  
  // 工具方法
  getByValue(value) {
    return Object.values(this).find(status => status.value === value && typeof status === 'object');
  },
  
  getDescription(value) {
    const status = this.getByValue(value);
    return status ? status.description : '未知状态';
  },
  
  getColor(value) {
    const status = this.getByValue(value);
    return status ? status.color : '#d9d9d9';
  },
  
  getValues() {
    return Object.values(this)
      .filter(status => typeof status === 'object')
      .map(status => status.value);
  },
  
  isValid(value) {
    return this.getValues().includes(value);
  },
  

});

/**
 * @description 配送订单状态
 * 
 */
export const DeliveryOrderStatus = Object.freeze({
  CREATED: {
    value: '0',
    description: '已创建',
    color: '#ffa500'
  },
  MOUNTED: {
    value: '1',
    description: '已挂载（已经成功挂载到无人机）',
    color: '#1890ff'
  },
  DELIVERING: {
    value: '2',
    description: '配送中',
    color: '#1890ff'
  },
  DELIVERED: {
    value: '3',
    description: '已送达',
    color: '#52c41a'
  },
  WAITING_RETURN: {
    value: '4',
    description: '待返航',
    color: '#faad14'
  },
  RETURNING: {
    value: '5',
    description: '返航中',
    color: '#1890ff'
  },
  COMPLETED: {
    value: '6',
    description: '已完成',
    color: '#52c41a'
  },
  
  // 工具方法
  getByValue(value) {
    return Object.values(this).find(status => status.value === value && typeof status === 'object');
  },
  
  getDescription(value) {
    const status = this.getByValue(value);
    return status ? status.description : '未知状态';
  },
  
  getColor(value) {
    const status = this.getByValue(value);
    return status ? status.color : '#d9d9d9';
  },
  
  getValues() {
    return Object.values(this)
      .filter(status => typeof status === 'object')
      .map(status => status.value);
  },
  
  isValid(value) {
    return this.getValues().includes(value);
  },
  
});

